/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DisableConnectionForLocationAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DisableConnectionForLocationAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/DisableConnectionForLocationAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let connectionCurrentLocationResourceStatusValueData = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'current_location_resource.status',
})
let globalCurrentLocationPermissionsHasAdminValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.permissions.has_admin',
})
let aggregateData = fromHelpers.getView(connectionCurrentLocationResourceStatusValueData, globalCurrentLocationPermissionsHasAdminValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}